function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@bydesign-ui/hooks';
export var Sorter = function (_Emitter) {
  _inherits(Sorter, _Emitter);

  var _super = _createSuper(Sorter);

  function Sorter() {
    var _this;

    _classCallCheck(this, Sorter);

    _this = _super.call(this);
    _this.dragging = false;
    _this.draggingData = null;
    _this.containers = {};
    return _this;
  }

  _createClass(Sorter, [{
    key: "register",
    value: function register(name, container) {
      this.containers[name] = container;
    }
  }, {
    key: "unregister",
    value: function unregister(name) {
      delete this.containers[name];
    }
  }, {
    key: "setSorter",
    value: function setSorter(from, to) {
      if (from != null) {
        var _container = this.containers[from.container];

        if (_container == null) {
          throw new Error('invalid container name = ' + from.container);
        }

        if (from.container === to.container) {
          _container.sortElement(from.index, to.index, to.data);

          return;
        }

        _container.removeElement(from.index);
      }

      var container = this.containers[to.container];

      if (container == null) {
        throw new Error('invalid container name = ' + to.container);
      }

      container.addElement(to.data, to.index);
    }
  }, {
    key: "setDragging",
    value: function setDragging(dragging) {
      var _this2 = this;

      var draggingData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (dragging !== this.dragging) {
        this.dragging = dragging;
        this.draggingData = draggingData;
        this.emit('dragging-change', dragging);
        Object.keys(this.containers).forEach(function (key) {
          var container = _this2.containers[key];

          if (container != null) {
            container.emit('dragging-change', dragging);
          }
        });
      }
    }
  }, {
    key: "isValidContainer",
    value: function isValidContainer(data, target) {
      var container = this.containers[target];

      if (container == null) {
        throw new Error('invalid container name = ' + target);
      }

      return container.isValidContainer(data);
    }
  }, {
    key: "getContainerMode",
    value: function getContainerMode(target) {
      var container = this.containers[target];

      if (container == null) {
        throw new Error('invalid container name = ' + target);
      }

      return container.getContainerMode();
    }
  }]);

  return Sorter;
}(Emitter);